import React from "react";
import PropTypes from "prop-types";

const Icon = ({ name, color, fontSize }) => {
  return <div className={`ay-icon-${name} ${color} ${fontSize}`}></div>;
};

Icon.defaultProps = {
  color: "text-gold",
  fontSize: "text-24",
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
